import React from 'react';
import {  View, ScrollView,Dimensions ,TouchableOpacity} from 'react-native';
import {  Appbar,Text,Switch,Divider,IconButton  } from 'react-native-paper';


var sports = [ 
  [
    "اسپینینگ",
    require("../assets/sportsicons1/spin.png"),
  ],
  [
    "ایروبیک",
    require("../assets/sportsicons1/rhytm.png"),
  ],
  [
    "بدنسازی",
    require("../assets/sportsicons1/gym.png"),
  ],
  [
    "تمرینات فانکشنال / کراسفیت",
    require("../assets/sportsicons1/cf.png"),
  ],
  [
    "تمرینات لس میلز",
    require("../assets/sportsicons1/bp.png"),
  ],
  [
    "تمرینات معلق",
    require("../assets/sportsicons1/trx.png"),
  ],
  [
    "جامپینگ فیتنس",
    require("../assets/sportsicons1/jump.png"),
  ],
  [
    "فیتنس",
    require("../assets/sportsicons1/fit.png"),
  ],
  [
    "دوچرخه سواری",
    require("../assets/sportsicons1/bike.png"),
  ],
  [
    "ورزش های آبی",
    require("../assets/sportsicons1/swim.png"),
  ],
  [
    "ورزش های آزاد",
    require("../assets/sportsicons1/free.png"),
  ],
  [
    "ورزش کودکان",
    require("../assets/sportsicons1/kids.png"),
  ],
  [
    "کیک بوکس / رزمی",
    require("../assets/sportsicons1/kb.png"),
  ],
  [
    "یوگا / پیلاتس",
    require("../assets/sportsicons1/yoga.png"),
  ],
  [
    "متفرقه",
    require("../assets/sportsicons1/other.png"),
  ],
] ;


export default class App extends React.Component {
  state = {
    period: global.filters.period,
    level: global.filters.level,
    order: global.filters.order,
    selectedSports :global.filters.sports,
    selectedFacilities :global.filters.facilities,
    onlyOnline: global.filters.level === "پیشرفته" ? true : false
  };

  onToggleSwitch = () => {
    this.setState({level: this.state.onlyOnline ? null : "پیشرفته", onlyOnline: !this.state.onlyOnline })
  }


  render() {
    console.log(this.state.level)
    
    return (
      <View style={{flex:1,backgroundColor:'#ebebeb'}}>

      <Appbar.Header style={{height:50,backgroundColor:'#21706c'}} >
        <Appbar.Action style={{marginRight:'auto'}} icon="check" color='white' onPress={() => {
          global.filters.sports = this.state.selectedSports ;
          global.filters.facilities = this.state.selectedFacilities;
          global.filters.order = this.state.order;
          global.filters.level = this.state.level;
          global.filters.period = this.state.period;
          this.props.route.params.onGoBack();
          this.props.navigation.navigate('Search') ;
          }} />
        <Text style={{color:'white', fontSize:18}}>فیلتر جستجو</Text>
        <Appbar.Action style={{marginLeft:'auto'}} icon="close" color='white' onPress={() => this.props.navigation.goBack()} />
       </Appbar.Header>

        
       <View style={{flexDirection:'row',backgroundColor:'white',justifyContent:'space-between',paddingVertical:15,paddingHorizontal:30}}>
         <Text>
           فقط فعالیت های آنلاین
         </Text>
         <Switch value={this.state.onlyOnline} onValueChange={this.onToggleSwitch} color='#2ebbc4' />
       </View>

       <Divider/>

       <View style={{flexDirection:'row',backgroundColor:'white',paddingVertical:15,paddingHorizontal:30}}>
         <Text>
           انتخاب ورزش
         </Text>
         <View style={{backgroundColor:'#2ebbc4',marginHorizontal:10,borderRadius:15}}>
           <Text style={{marginHorizontal:10, color:'white'}}>{this.state.selectedSports.length === 0 ? 'همه' : this.state.selectedSports.length}</Text>
         </View>
       </View>

       <ScrollView contentContainerStyle={{paddingHorizontal:10,paddingBottom:20}}>

         <View style={{flexDirection:'row',justifyContent:'space-between'}}>
           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[0][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[0][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[0][1]} size={70} color={this.state.selectedSports.indexOf( sports[0][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[0][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[0][0]}</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[1][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[1][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[1][1]} size={70} color={this.state.selectedSports.indexOf( sports[1][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[1][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[1][0]}</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[2][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[2][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[2][1]} size={70} color={this.state.selectedSports.indexOf( sports[2][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[2][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[2][0]}</Text>
           </TouchableOpacity>

         </View>

         <View style={{flexDirection:'row',justifyContent:'space-between'}}>
         <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[3][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[3][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[3][1]} size={70} color={this.state.selectedSports.indexOf( sports[3][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[3][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[3][0]}</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[4][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[4][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[4][1]} size={70} color={this.state.selectedSports.indexOf( sports[4][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[4][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[4][0]}</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[5][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[5][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[5][1]} size={70} color={this.state.selectedSports.indexOf( sports[5][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[5][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[5][0]}</Text>
           </TouchableOpacity>

         </View>

         <View style={{flexDirection:'row',justifyContent:'space-between'}}>
         <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[6][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[6][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[6][1]} size={70} color={this.state.selectedSports.indexOf( sports[6][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[6][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[6][0]}</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[7][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[7][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[7][1]} size={70} color={this.state.selectedSports.indexOf( sports[7][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[7][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[7][0]}</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[8][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[8][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[8][1]} size={70} color={this.state.selectedSports.indexOf( sports[8][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[8][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[8][0]}</Text>
           </TouchableOpacity>

         </View>

         <View style={{flexDirection:'row',justifyContent:'space-between'}}>
         <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[9][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[9][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[9][1]} size={70} color={this.state.selectedSports.indexOf( sports[9][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[9][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[9][0]}</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[10][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[10][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[10][1]} size={70} color={this.state.selectedSports.indexOf( sports[10][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[10][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[10][0]}</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[11][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[11][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[11][1]} size={70} color={this.state.selectedSports.indexOf( sports[11][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[11][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>بادی ویت</Text>
           </TouchableOpacity>

         </View>

         <View style={{flexDirection:'row',justifyContent:'space-between'}}>
          <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[12][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[12][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[12][1]} size={70} color={this.state.selectedSports.indexOf( sports[12][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[12][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[12][0]}</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[13][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[13][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[13][1]} size={70} color={this.state.selectedSports.indexOf( sports[13][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[13][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[13][0]}</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{width:(Dimensions.get('window').width-20)/3,height:(Dimensions.get('window').width-20)/3,justifyContent:'center',alignItems:'center'}}
              onPress={() => {
                let selectedSports = this.state.selectedSports;
                let indexOfSport = selectedSports.indexOf( sports[14][0] ) ;
                if( indexOfSport >= 0 )
                  {
                    selectedSports.splice( indexOfSport , 1 );
                  }
                  else {
                    selectedSports.push( sports[14][0] ) ;
                  }
                    this.setState({selectedSports}) ;
                  }}>
             <IconButton style={{margin:-20}} icon={sports[14][1]} size={70} color={this.state.selectedSports.indexOf( sports[14][0] ) >= 0 ? "#21706C" : 'grey'}/>
             <Text style={{color:this.state.selectedSports.indexOf( sports[14][0] ) >= 0 ? "#21706C" : 'grey',textAlign:'center'}}>{sports[14][0]}</Text>
           </TouchableOpacity>

         </View>
          
      </ScrollView>
      </View>
    );
  }
}
